import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const CommentContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  border-bottom: 1px solid ${select('neutralDarkGray')};
  padding-bottom: 16px;
`;

const HeaderConteiner = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const CommentRaiting = styled.div`
  border-radius: 4px;
  background-color: ${select('neutralGray')};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 0px 8px;
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  height: 24px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

const DateContainer = styled.div`
  display: flex;
  color: ${select('midDarkGrayAux')};
`;

const CustomerComment = styled.div`
  display: block;
  width: 100%;
  margin-top: 14px;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  ::before {
    content: '"';
  }
  ::after {
    content: '"';
  }
  white-space: break-spaces;
`;

const Recomended = styled.div`
  width: auto;
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 2px 10px;
  align-self: end;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: ${({ recommended, neutralComment }) => {
    if (neutralComment) return select('neutralDarkGrayII');
    if (!recommended) return select('redNoTRecommended');
    return select('greenRecommended');
  }};
  border: 1px solid ${select('neutralDarkGray')};
  border-radius: 4px;
  background: ${({ recommended, neutralComment }) => {
    if (neutralComment) return select('neutralDarkGray');
    if (!recommended) return select('creamOrange');
    return select('greenRecommendedBg');
  }};
  padding: 2px 10px;
  margin-top: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const RecomendedImg = styled.img``;

const StarImg = styled.img`
  width: 16px;
  height: 16px;
`;

export {
  CommentContainer,
  CommentRaiting,
  HeaderConteiner,
  DateContainer,
  CustomerComment,
  Recomended,
  RecomendedImg,
  StarImg
};
